import React from 'react'
import ReactResizeDetector from 'react-resize-detector'
import { CacheProvider } from '@emotion/react'
import { PAYPAL_THEME, ThemeWrapper } from '@paypalcorp/pp-react'
import createCache from '@emotion/cache'
import { ContextProvider as WorldReadyContextProvider } from '@paypalcorp/worldready-react'

import ErrorBoundary from 'components/ErrorBoundary'
import { isTest } from 'constants/environment'
import ErrorFallback from 'views/Shopping/components/ErrorFallback'
import clientData, { init as initClientData } from './lib/client-data'
import { initWorldReady } from './lib/initWorldReady'
import PortalFooter from './shoplist-app/shopping/components/v2/PortalFooter'
import { render } from 'react-dom'
import ResizeObserverContext from './lib/resize-observer-context'
import StoreProfilePage from './shoplist-app/store-profile/StoreProfilePage'
import { get } from 'lodash'
import { ModalContextProvider } from './contexts/ModalContext/ModalContext'
import OfferDetailsModalHandler from './shoplist-app/shopping/components/v2/OfferDetailsModalHandler'
import { RecentSearchesProvider } from './contexts/RecentSearchesContext/RecentSearchesContext'

initClientData()
initWorldReady(clientData.worldReady, isTest())

render(
  <WorldReadyContextProvider locale={clientData.locality.locale}>
    <ErrorBoundary FallbackComponent={() => <ErrorFallback useGenericError />}>
      <CacheProvider
        value={createCache({ key: 'store-profile', prepend: true })}
      >
        <ReactResizeDetector handleWidth>
          {({ width }: { width: number }) => (
            <ResizeObserverContext.Provider value={width}>
              <div id="resize-observer">
                <ThemeWrapper theme={PAYPAL_THEME}>
                  <RecentSearchesProvider>
                    <ModalContextProvider>
                      <OfferDetailsModalHandler fptiSource="store profile page" />
                      <StoreProfilePage
                        merchantId={get(clientData, 'merchantId') ?? ''}
                      />
                      <PortalFooter />
                    </ModalContextProvider>
                  </RecentSearchesProvider>
                </ThemeWrapper>
              </div>
            </ResizeObserverContext.Provider>
          )}
        </ReactResizeDetector>
      </CacheProvider>
      `
    </ErrorBoundary>
  </WorldReadyContextProvider>,
  document.getElementById('root')
)
